import { RadioGroupField, RadioGroupFieldProps } from 'components/form'
import { TipoAtendimentoPainelChamadaEnum } from 'view/atendimentos/list/actions/chamar/model-painelChamada'

export const TipoAtendimentoPainelChamadasOptions = [
  { value: TipoAtendimentoPainelChamadaEnum.ACOLHIMENTO, label: 'Acolhimento' },
  { value: TipoAtendimentoPainelChamadaEnum.ATENDIMENTO, label: 'Atendimento' },
]

type TipoAtendimentoPainelChamadasRadioFieldProps = Omit<
  RadioGroupFieldProps<TipoAtendimentoPainelChamadaEnum>,
  'options'
>

export const TipoAtendimentoPainelChamadasRadioGroupField = (props: TipoAtendimentoPainelChamadasRadioFieldProps) => {
  return (
    <RadioGroupField<TipoAtendimentoPainelChamadaEnum>
      label='Chamar para'
      options={TipoAtendimentoPainelChamadasOptions}
      {...props}
    />
  )
}
